import SMSProtocolHandler from './SMSProtocolHandler'

export const PROTOCOL = 'mms'

export default class MMSProtocolHandler extends SMSProtocolHandler {
  override readonly protocol = PROTOCOL
}
